/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pool: NonNullable<unknown> }} Action_Start_With_PoolInputs */

const bn_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`শুরু করুন ${i?.pool}`)
};

const de_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start ${i?.pool}`)
};

const el_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Έναρξη ${i?.pool}`)
};

const en_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start ${i?.pool}`)
};

const es_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniciar ${i?.pool}`)
};

const fr_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencer ${i?.pool}`)
};

const hi_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रारंभ ${i?.pool}`)
};

const hu_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Indítás ${i?.pool}`)
};

const id_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mulai ${i?.pool}`)
};

const it_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia ${i?.pool}`)
};

const ja_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pool} を開始`)
};

const ko_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pool} 시작`)
};

const nl_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begin ${i?.pool}`)
};

const pl_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rozpocznij ${i?.pool}`)
};

const pt_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniciar ${i?.pool}`)
};

const ru_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начать ${i?.pool}`)
};

const sv_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Börja ${i?.pool}`)
};

const tr_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pool} ile başla`)
};

const uk_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Початок ${i?.pool}`)
};

const vi_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bắt đầu ${i?.pool}`)
};

const zh_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开始 ${i?.pool}`)
};

const zh_hant_action_start_with_pool = /** @type {(inputs: Action_Start_With_PoolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`開始 ${i?.pool}`)
};

/**
* | output |
* | --- |
* | "Start {pool}" |
*
* @param {Action_Start_With_PoolInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_start_with_pool = /** @type {((inputs: Action_Start_With_PoolInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Start_With_PoolInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_start_with_pool(inputs)
	if (locale === "de") return de_action_start_with_pool(inputs)
	if (locale === "el") return el_action_start_with_pool(inputs)
	if (locale === "en") return en_action_start_with_pool(inputs)
	if (locale === "es") return es_action_start_with_pool(inputs)
	if (locale === "fr") return fr_action_start_with_pool(inputs)
	if (locale === "hi") return hi_action_start_with_pool(inputs)
	if (locale === "hu") return hu_action_start_with_pool(inputs)
	if (locale === "id") return id_action_start_with_pool(inputs)
	if (locale === "it") return it_action_start_with_pool(inputs)
	if (locale === "ja") return ja_action_start_with_pool(inputs)
	if (locale === "ko") return ko_action_start_with_pool(inputs)
	if (locale === "nl") return nl_action_start_with_pool(inputs)
	if (locale === "pl") return pl_action_start_with_pool(inputs)
	if (locale === "pt") return pt_action_start_with_pool(inputs)
	if (locale === "ru") return ru_action_start_with_pool(inputs)
	if (locale === "sv") return sv_action_start_with_pool(inputs)
	if (locale === "tr") return tr_action_start_with_pool(inputs)
	if (locale === "uk") return uk_action_start_with_pool(inputs)
	if (locale === "vi") return vi_action_start_with_pool(inputs)
	if (locale === "zh") return zh_action_start_with_pool(inputs)
	return zh_hant_action_start_with_pool(inputs)
});